<template>
  <b-modal ref="materialsAndEquipmentModal" title="資器材集計表出力" :no-close-on-backdrop="true" @ok="handleOk" okTitle="出力" cancelTitle="キャンセル">
    <b-overlay :show="overlayShow" rounded="sm">
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <div class="row mb-2">
          <label for="continent" class="control-label col-sm-12">施行日</label>
          <div class="col-sm-5 pr-0">
            <input type="date" name="continent" id="wedding-date-from" class="form-control input-sm search-project-condition" invalid-feedback="必須項目です" v-model="weddingDateFrom"/>
          </div>
          <div class="col-sm-1 p-0 mt-2 text-center">
            <span>〜</span>
          </div>
          <div class="col-sm-5 pl-0">
            <input type="date" name="continent" id="wedding-date-to" class="form-control input-sm search-project-condition" invalid-feedback="必須項目です" v-model="weddingDateTo"/>
          </div>
        </div>
        <b-form-group label="施設" label-for="facility">
          <v-select id="wedding-date" v-model="facility" :options="facilities" :close-on-select="false" :deselectFromDropdown="true" multiple></v-select>
        </b-form-group>
      </form>
    </b-overlay>
  </b-modal>
</template>

<script>
import FacilityListModel from '@/models/FacilityListModel'
import CreateMaterialsAndEquipmentAggregationSheetsModel from '@/models/CreateMaterialsAndEquipmentAggregationSheetsModel'
import vSelect from 'vue-select'
import Vue from 'vue'
import 'vue-select/dist/vue-select.css'
Vue.component('v-select', vSelect)
export default {
  name: 'MaterialsAndEquipmentModal',
  data () {
    return {
      overlayShow: false,
      weddingDateFrom: '',
      weddingDateTo: '',
      facilities: [],
      facility: [],
      expanded: false,
      allSelected: false,
      prodBaseCode: []
    }
  },
  async mounted () {
    // 施設一覧の取得
    const facilityList = await FacilityListModel.getApi(this.$bvModal, {}, () => {})
    if (facilityList !== '') {
      this.facilities.push({
        label: '全て選択',
        code: '全て選択'
      })
    }
    for (const facility of facilityList['facilities']['records']) {
      this.facilities.push({
        label: facility['施設名']['value'],
        code: facility['施設名']['value'],
        prodBaseCode: facility['制作拠点コード']['value']
      })
    }
  },
  methods: {
    showModal () {
      this.$refs.materialsAndEquipmentModal.show()
    },
    handleOk (bvModalEvent) {
      bvModalEvent.preventDefault()
      this.handleSubmit()
    },
    handleSubmit () {
      this.overlayShow = true
      if (!this.validate()) {
        this.overlayShow = false
        return false
      }

      const reqData = {
        weddingDateFrom: this.weddingDateFrom,
        weddingDateTo: this.weddingDateTo,
        facilityName: this.facility,
        prodBaseCode: this.prodBaseCode[0]
      }

      const closeModal = () => {
        this.overlayShow = false
        this.$refs.materialsAndEquipmentModal.hide()
      }
      CreateMaterialsAndEquipmentAggregationSheetsModel.postApi(this.$bvModal, reqData, (res) => {
        window.open(res.data.items.filePath, '_blank')
      }, closeModal)
    },
    validate () {
      console.log(this.facility)
      console.log(this.weddingDateFrom)
      console.log(this.weddingDateTo)
      console.log(this.prodBaseCode)
      if (this.weddingDateFrom === '' || this.weddingDateTo === '') {
        this.$bvModal.msgBoxOk('施工日は必須です。')
        return false
      }
      if (this.facility.length === 0) {
        this.$bvModal.msgBoxOk('施設は必須です。')
        return false
      }
      const from = new Date(this.weddingDateFrom)
      const to = new Date(this.weddingDateTo)
      let diffMilliSec = to - from
      if (parseInt(diffMilliSec) < 0) {
        this.$bvModal.msgBoxOk('施工日の終了日が開始日より前の日付になっています。終了日には開始日以降の日付を指定して下さい。')
        return false
      }
      for (const facilityData of this.facility) {
        this.prodBaseCode.push(facilityData['prodBaseCode'])
      }
      if (!this.prodBaseCode.every(v => v === this.prodBaseCode[0])) {
        this.$bvModal.msgBoxOk('異なる制作拠点の施設が含まれています。全て同一の制作拠点になるように選択してください。')
        this.prodBaseCode = []
        return false
      }
      return true
    }
  },
  watch: {
    facility: function (val) {
      if (val.length !== 0) {
        if (val[val.length - 1].code === '全て選択') {
          if (this.allSelected === false) {
            const selectedList = this.facilities.concat()
            selectedList.shift()
            this.facility = selectedList
            this.allSelected = true
          } else {
            this.facility = []
            this.allSelected = false
          }
        } else {
          if (val.length === this.facilities.length - 1) {
            this.allSelected = true
          } else {
            this.allSelected = false
          }
        }
      }
    }
  }
}
</script>

<style>

.vs__dropdown-option--selected {
  background: #D9E5FF;
  color: #ffffff;
}

</style>



// WEBPACK FOOTER //
// src/components/MaterialsAndEquipmentModal.vue